'use es6';

import { catchError } from 'rxjs/operators/catchError';
import { map } from 'rxjs/operators/map';
import { mergeMap } from 'rxjs/operators/mergeMap';
import { of } from 'rxjs/observable/of';
import { startWith } from 'rxjs/operators/startWith';
import { FETCHED_ADS_DATA } from '../actions/ActionTypes';
import { requestAdsData, requestAdsDataFailed, receiveAdsData } from '../actions/AdsActions';
export default ((action$, _, {
  AdsClient
}) => action$.ofType(FETCHED_ADS_DATA).pipe(mergeMap(() => AdsClient.fetchAdsData().pipe(map(receiveAdsData), catchError(error => of(requestAdsDataFailed(error))), startWith(requestAdsData())))));